module.exports = "<full-calendar #mycalendar [options]='calendarOptions'></full-calendar>"